export default function Redo() {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.19126 4.04927C1.68508 3.28999 2.31065 2.63125 3.03482 2.09914L1.4285 0.5H6.10337V5.154L3.91928 2.97964C2.26393 4.12898 1.23712 6.03262 1.23712 8.06921C1.23712 11.4907 4.04666 14.2743 7.5 14.2743C10.9533 14.2743 13.7629 11.4907 13.7629 8.06921C13.7629 7.23251 13.5978 6.42105 13.2724 5.65744L14.412 5.1806C14.8022 6.09591 15 7.06777 15 8.06921C15 12.1666 11.6355 15.5 7.5 15.5C3.36447 15.5 -9.53674e-07 12.1666 -9.53674e-07 8.06921C-9.53674e-07 6.63763 0.41192 5.2476 1.19126 4.04927Z" fill="#191936" />
    </svg>
  )
}
